import { cleanFetch, defaultGetOptions, genericGet, handle } from "../api_utils"
import { AdviceFilter, AdviceFilterAPI, BookSearchResponse, CollectionType, MoodGroupListWithCover, Themes, apiToFilter } from "../bookarang/types"
import { WiseBook, WiseBookDetails } from "../wise/types"
import { SearchOn, emptyBook } from "./types"
import { HttpResult } from "widgets-for-react"

export type TextWith4Covers = {
  name: string,
  covers: string[]
}

const get = <AppResult>(endpoint: string, converter?: (input: unknown) => AppResult) =>
  genericGet<AppResult>(`/api/v1/collection${endpoint}`, converter)

export const fetchPopularThemePrompts = get<TextWith4Covers[]>(
  '/advice/prompts/popularthemes')

export const themeSearch = (searchTerm: string) => get<SearchOn[]>(
  `/advice/prompts/themes?search=${searchTerm}`,
  (res: Themes) => res.themes.map<SearchOn>(t => ({ label: t, value: emptyBook }))
)

export const origThemeSearch = async (searchTerm: string): Promise<HttpResult<SearchOn[]>> => {
  const res = await cleanFetch(`/api/v1/collection/advice/prompts/themes?search=${searchTerm}`, defaultGetOptions())

  const temp = await handle<Themes>(res)
  if (temp.kind != 'result') return (temp as HttpResult<SearchOn[]>)
  const searchResults: SearchOn[] = [];
  temp.value.themes.forEach((t) => searchResults.push({label: t, value: emptyBook}))
  return { ...temp, value: searchResults }
}

const moodOrder = {
  "Romans": 0,
  "Thrillers": 1,
  "Non-fictie": 2,
}

export const fetchMoodPrompts = get<MoodGroupListWithCover[]>(
  '/advice/prompts/moods',
  (moods: MoodGroupListWithCover[]) => moods.sort((a, b) => {
    const a1 = moodOrder[a.id] ?? 3
    const b1 = moodOrder[b.id] ?? 3
    return a1 - b1
  })
)

export const bookSearch = (searchTerm: string) => get<SearchOn[]>(
  `/advice/prompts/books?search=${searchTerm}`,
  (response: BookSearchResponse) => response.data.map((book) => {
    const title = book.Title ? book.Title[0] : ""
    const author = book.FullName ? book.FullName[0] : ""
    const isbn = book.EAN ? book.EAN[0] : ""
    return {
      label: `${title ? `${title} - ` : ""}${author}`,
      value: { isbn: isbn, author: author, title: title },
    }
  }))

export const fetchPopularBookPrompts = get<WiseBook[]>(
  `/advice/prompts/popularbooks`)

export const fetchLocationPrompts = get<string[]>(
  `/advice/prompts/locations`)

export const fetchAdvice = (collectionType: CollectionType, id: string) => get<WiseBook[]>(
  `/advice/${collectionType}/${id}`)

export const fetchAdviceFilters = (collectionId: string) => get<AdviceFilter[]>(
  `/advice/filters/${collectionId}`,
  (arr: AdviceFilterAPI[]) => arr.map(apiToFilter))

export const fetchBookWiseDetails = (wiseId: string) => get<WiseBookDetails>(
  `/wiseDetails/${wiseId}`)
